import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SubChangesPage } from '@/features/subcontracts/changes-page';

const searchSchema = z.object({
  tab: z.enum(['variations', 'backcharges', 'instructions']).optional().catch(undefined),
  subcontractId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/changes')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <SubChangesPage projectId={projectId} tab={search.tab} subcontractId={search.subcontractId} />
  );
}
